import { BaseService } from './base.service';
import { FacilityType } from '@/types/booking.types';

// `facilityType` comes from the API deliberately: the facility-to-service-type
// mapping is FACILITY_TYPE_SERVICE_TYPE_MAP on the server (locked to the 4
// ledger-eligible types) and must not be duplicated client-side, or the two
// can drift (CONTEXT.md code_context).
export interface MemberEntitlementSummary {
  serviceType: string;
  facilityType: FacilityType;
  remainingCount: number;
  // Phase 345 (D-04/D-06): whether this service type's BookingType is
  // active at the member's home location; false means the row must render
  // disabled/greyed but stay visible — never hidden.
  active: boolean;
}

export interface MemberEntitlementListResponse {
  data: MemberEntitlementSummary[];
}

class MemberEntitlementService extends BaseService {
  constructor() {
    super('/member-entitlements');
  }

  /**
   * Get the authenticated member's own entitlement balances.
   */
  async getMyBalances(): Promise<MemberEntitlementListResponse> {
    return this.get<MemberEntitlementListResponse>('/me');
  }
}

export const memberEntitlementService = new MemberEntitlementService();
export default memberEntitlementService;
